var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.544,
    height: 16.943,
    viewBox: "0 0 14.544 16.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Paper",
    "data-name": "Iconly/Light-Outline/Paper",
    transform: "translate(-3.001 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper",
    transform: "translate(3.001 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M9.361,0a.643.643,0,0,1,.108.009h.117a.641.641,0,0,1,.461.2l4.32,4.5a.639.639,0,0,1,.178.443v7.818a3.938,3.938,0,0,1-3.795,3.975H3.818A3.911,3.911,0,0,1,0,13.137V3.83A3.922,3.922,0,0,1,3.9.01H9.254A.643.643,0,0,1,9.361,0Zm-.64,1.289H3.9a2.633,2.633,0,0,0-2.62,2.556v9.122a2.633,2.633,0,0,0,2.566,2.7h6.878a2.661,2.661,0,0,0,2.541-2.692V5.956H11.552a2.842,2.842,0,0,1-2.83-2.836Zm.48,9.465a.64.64,0,0,1,0,1.279H4.6a.64.64,0,0,1,0-1.279Zm-1.744-3.2a.64.64,0,1,1,0,1.279H4.6a.64.64,0,1,1,0-1.279ZM10,2.006V3.121a1.559,1.559,0,0,0,1.552,1.557h1.011Z",
    transform: "translate(-0.001 0)",
    fill: "#4a4ade",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionIcon);
export default __webpack_public_path__ + "static/media/DescriptionIcon.7497f36d3f1bb8e9830d74bee418406e.svg";
export { ForwardRef as ReactComponent };